import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard, Row } from '../../styled';
import _ from 'lodash';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { formatNumber } from 'src/utils/misc';
import { DangerTooltip } from '../comps';

interface AIFV2Props {
  value: DashboardQuery['dashboard']['averageIncidentFrequency'];
  state: AssessmentState;
  noIncidentsComponent?: React.ReactNode;
}

export const AIFV2: React.FC<AIFV2Props> = ({ value, state, noIncidentsComponent }) => {
  return (
    <BaseCard>
      <span className="c-title">Average Incident Frequency</span>
      <div style={{ flex: 1 }} />

      {state === 'NO_SCENARIOS' ? (
        <DangerTooltip state={state} />
      ) : (
        <>
          {noIncidentsComponent ? (
            noIncidentsComponent
          ) : (
            <div>
              <Row>
                <Poppins px={14} weight={500} nowrap color="cflowerBlue">
                  Mean time between incidents
                </Poppins>
                <div className="separator" />
                {_.isNil(value?.meantimeBetweenIncidents) ? (
                  <Poppins weight={600} color="gp1" px={14}>
                    N/A
                  </Poppins>
                ) : (
                  <Poppins weight={600} color="gp1" px={14}>
                    {formatNumber(value?.meantimeBetweenIncidents)} days
                  </Poppins>
                )}
              </Row>

              <Row>
                <Poppins px={14} weight={500} nowrap color="cflowerBlue">
                  Mean time between near misses
                </Poppins>
                <div className="separator" />
                {_.isNil(value?.meantimeBetweenNearMisses) ? (
                  <Poppins weight={600} color="gp1" px={14}>
                    N/A
                  </Poppins>
                ) : (
                  <Poppins weight={600} color="gp1" px={14}>
                    {formatNumber(value?.meantimeBetweenNearMisses)} days
                  </Poppins>
                )}
              </Row>
            </div>
          )}
        </>
      )}
    </BaseCard>
  );
};
